import React, { useEffect, useState } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";

import DownloadApp from "../../component/download-app/downloadApp";
import {
	getBlogDetailByTitle,
	getLatestBlogs,
	getPopularBlogs,
} from "../../actions/get-calls";
import { APP_SUB_FOLDER, decodeString, DefaultMetaTag, encodeString } from "../../constants/app-constants";
import BreadcrumbWithUrl from "../../component/breadcrumb/breadcrumb-with-url";
import { Helmet } from "react-helmet";
import Helmet_SEO_META from "../../component/seo_meta";
import { getMetaData } from "../../actions/cms-api-handlers";



const BlogDetails = () => {
	const { title, slug } = useParams();
	const [blog, setBlog] = useState({});
	const [activeRecentPost, setActiveRecentPost] = useState(1);
	const [latestBlogs, setLatestBlogs] = useState([]);
	const [popularBlogs, setPopularBlogs] = useState([]);
	const fetchBlogDetail = async () => {
		if (slug) {
			const response = await getBlogDetailByTitle(slug);
			if (
				response &&
				response.data &&
				Array.isArray(response.data) &&
				response.data.length > 0
			) {
				setBlog(response.data[0]);
			}
		}
	};
	const fetchLatestPosts = async () => {
		const response = await getLatestBlogs();
		setLatestBlogs(response.data);
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	const fetchPopularPosts = async () => {
		const response = await getPopularBlogs();
		setPopularBlogs(response.data);
	};
	useEffect(() => {
		fetchBlogDetail();
		fetchLatestPosts();
		fetchPopularPosts();
	}, []);
	const breadCrumbData = [
		{ type: 1, url: `${APP_SUB_FOLDER}/`, name: "Home" },
		{ type: 1, url: `${APP_SUB_FOLDER}/health-blogs`, name: "Health Blogs" },
		{ type: 3, url: "", name: blog.title || '' },
	];

    // add meta tag
    const location = useLocation();
	const [getSeoMata, setGetSeoMata]=useState("")
	const pageURL = window.location.origin + window.location.pathname;
	const [SEO_META, setSEO_META]=useState({
		title: DefaultMetaTag.title,
		description: DefaultMetaTag.description,
		keywords:DefaultMetaTag.keyword,
	    pageURL: pageURL
	})

	useEffect(() => {
		setSEO_META({
			title: blog.meta_title,
			description: blog.meta_description,
			keywords: blog.blogkeyword,
			pageURL: pageURL
		})
	}, [blog])

	// useEffect(() => {
	//   const url =    Domain + location.pathname;
	//   getMetaData(url).then(function (response) {
	// 	setGetSeoMata(response.data) 
	// })
	// .catch(function (err) {
	// });  
	// }, []);
	// useEffect(() => {   
	//   if(getSeoMata && getSeoMata?.status == true){
	// 		  setSEO_META({
	// 			title: getSeoMata.data[0].title,
	// 			description: getSeoMata.data[0].description,
	// 			keywords: getSeoMata.data[0].keyword,
	// 			pageURL: pageURL
	// 		})
	//   }
	// }, [getSeoMata])
	return (
		<React.Fragment>
		      <Helmet_SEO_META SEO_META={SEO_META} />
			<Container className="min-body-heightt">
				<BreadcrumbWithUrl breadcrumbs={breadCrumbData} />

				{/* <Breadcrumb url="" chlidrenUrl="" primaryText="" text="blog" /> */}
				<h5 className="">Health Blogs</h5>
				<h1>{blog.title}</h1>
				<p>{blog.short_description}</p>
				<div className="row">
					<div className="col-lg-12">
						<div className="mhc-blog-details">
							<figure className="figure">
								<img
									src={blog.blog_img}
									className="figure-img img-fluid rounded"
									alt="MyHealthcare Health Blog"
								/>
								<figcaption className="figure-caption">
									{blog.title}
								</figcaption>
							</figure>
							<div>
								<div
									className="blog-details-body"
									dangerouslySetInnerHTML={{ __html: blog.blog }}
								></div>
							</div>
						</div>
					</div>
					<div className="col-lg-4 mt-4 mt-md-0">
						{/* <h4 className="fs-4 text-secondary">By Specialities</h4>
						<ul className="list-unstyled d-flex flex-wrap mt-4">
							{blogtag.map((item, index) => (
								<li key={index}>
									<Link
										className="btn btn-outline-secondary rounded-1  mb-3 me-3"
										to=""
									>
										{item.tag}
									</Link>
								</li>
							))}
						</ul> */}

						{/* <Card className="mhc-recent-post">
							<Card.Header>
								<h4 className="fs-4 text-secondary">Recent Posts</h4>
								<div className="d-flex mt-2">
									<Link
										type="link"
										to=""
										className={`btn rounded-1 px-5 ${activeRecentPost === 1 ? 'btn-primary' : 'btn-outline-primary'}`}
										onClick={() => {
											setActiveRecentPost(1);
										}}
									>
										Latest
									</Link>
									<Link
										type="link"
										className={`btn rounded-1 px-5 ${activeRecentPost === 1 ? 'btn-primary' : 'btn-outline-primary'} ms-3`}
										to=""
										onClick={() => {
											setActiveRecentPost(2);
										}}
									>
										Popular
									</Link>
								</div>
							</Card.Header>
							<Card.Body>
								{activeRecentPost === 1 && latestBlogs && Array.isArray(latestBlogs) &&
									latestBlogs.map((item, index) => (
										<div className="blog-post" key={index}>
											<div>
												<img
													src={item.blog_img}
													alt="Item Blog"
													style={{ height: "50px", width: "50px" }}
												/>
											</div>
											<div className="ms-2">
												<Link to="">{item.title}</Link>
											</div>
										</div>
									))}
								{
									activeRecentPost === 2 && popularBlogs && Array.isArray(popularBlogs) &&
									popularBlogs.map((item, index) => (
										<div className="blog-post" key={index}>
											<div>
												<img
													src={item.blog_img}
													alt="Blog Images"
													style={{ height: "50px", width: "50px" }}
												/>
											</div>
											<div className="ms-2">
												<Link to="">{item.title}</Link>
											</div>
										</div>
									))
								}
							</Card.Body>
						</Card> */}
					</div>
				</div>
			</Container>
			<DownloadApp />
		</React.Fragment>
	);
};
export default BlogDetails;